import { addDoc, collection, doc, getDoc, getDocs, setDoc, updateDoc } from 'firebase/firestore';
import './firebase';
import { db } from './firebase';

//Users

//Add Student
const addStudent = async(uid, name, email, classNo, sponsership, schoolID, gender, familyIncome, dob, disability, noOfSiblings, distanceFromSchool, toiletFacilities, drinkingWater, previousPregnency, marks) => {
    try {

        await setDoc(doc(db, "schools/" + schoolID + "/students", uid), {
            uid: uid,
            name: name,
            email: email,
            classNo: classNo,
            sponser: sponsership,
            role: "Student",
            schoolID: schoolID,
            gender: gender,
            familyIncome: familyIncome,
            dob: dob,
            disability: disability,
            noOfSiblings: noOfSiblings,
            distanceFromSchool: distanceFromSchool,
            drinkingWater: drinkingWater,
            toiletFacilities: toiletFacilities,
            drinkingWater: drinkingWater,
            previousPregnency: previousPregnency,
            percentage: marks,
        });
        return true;
    } catch {
        return false;
    }

}

//Add Teacher
const addTeacher = async(user, name, courseID, schoolID, dob) => {
    try {
        await setDoc(collection(db, "schools/" + schoolID + "/teachers"), {
            uid: user.uid,
            name,
            email: user.email,
            dob,
            courseID,
            role: "Teacher",
            schoolID,

        });
        return true;
    } catch {
        return false;
    }
}

// Get all teacher
const getAllTeachers = async(schoolID) => {
    const teachersRef = collection(db, `schools/${schoolID}/teachers`);
    const querySnapshot = await getDocs(teachersRef);
    const teachers = [];
    querySnapshot.forEach((doc) => {
        const teacherData = doc.data();
        console.log(teacherData)
        const teacher = {
            id: doc.id,
            name: teacherData.name,
            email: teacherData.email,
            dob: teacherData.dob,
            courseID: teacherData.courseID,
            role: teacherData.role,
            schoolID: teacherData.sce6384f6be9c2f3a635763ea0fb3309fc4dc4f32ehoolID,
        };
        teachers.push(teacher);
    });

    return teachers;
};

// Get all student
const getAllstudents = async(schoolID) => {
    const studentsRef = collection(db, `schools/${schoolID}/students`);
    const querySnapshot = await getDocs(studentsRef);
    const students = [];
    querySnapshot.forEach((doc) => {
        const studentData = doc.data();
        console.log(studentData)
        const student = {
            id: doc.id,
            name: studentData.name,
            email: studentData.email,
            dob: studentData.dob,
            courseID: studentData.courseID,
            role: studentData.role,
            schoolID: studentData.sce6384f6be9c2f3a635763ea0fb3309fc4dc4f32ehoolID,
        };
        students.push(student);
    });

    return students;
};

const getUserData = async() => {


    const docRef = doc(db, "users", localStorage.getItem("uid"));
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
        console.log("Document data:", docSnap.data());
        return docSnap.data();
    } else {
        console.log("No such document!");
    }

}
const getTeacher = async(uid) => {
    const schoolID = '001'
    console.log(uid)
    const teachersRef = collection(db, 'schools', schoolID, 'teachers');
    const docRef = doc(teachersRef, uid);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
        console.log("Document data:", docSnap.data());
        return docSnap.data();
    } else {
        console.log("No such document!");
    }

}

const getStudent = async(uid) => {
    const schoolID = '001'

    const teachersRef = collection(db, 'schools', schoolID, 'students');
    const docRef = doc(teachersRef, uid);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
        console.log("Document data:", docSnap.data());
        return docSnap.data();
    } else {
        console.log("No such document!");
    }

}


const addQuestionair = async(schoolID, teacherUID, percentage, comment) => {

    try {
        await addDoc(collection(db, "schools/" + schoolID + "/teachers/" + teacherUID + "/reviews"), {
            percentage: percentage,
            comment: comment
        });
        return true;
    } catch (e) {
        console.error(e);
        return false;
    }
}

const getQuestionnaires = async(schoolID, teacherUID) => {
    try {
        const snapshot = await getDocs(collection(db, `schools/${schoolID}/teachers/${teacherUID}/reviews`));
        return snapshot.docs.map(doc => doc.data());
    } catch (e) {
        console.error(e);
        return null;
    }
}


export {
    addTeacher,
    addStudent,
    getUserData,
    getAllTeachers,
    getAllstudents,
    getTeacher,
    getStudent,
    addQuestionair,
    getQuestionnaires,
};